/**
 * api Url
 */
import host from 'Host';

const commonApi = {
    //基础接口
    //fileUpload: '/api/fileUpload/uploadPic',//上传图片 图片流
    uploadBase64: '/admin/file/upbase64',//上传图片 base64
    refreshImage: '/admin/captcha/get',//图形验证码
    exportExcel: '/admin/export/export',//导出
    exportV3: '/admin/export/exportV3',//导出
    sendSms: '/admin/captcha/sendSms', //发送验证码
    login: '/admin/account/login',//登录
    logout: '/admin/account/logout',//退出
    userInfo: '/admin/commercial/info',//用户信息
    changePassword: '/admin/account/changePwd',//修改密码
    schoolInCommercial: '/admin/commercial/schoollist', //公司关联的学校
    getMenuList: 'api/commercialmenu/getmenuList', // 权限菜单

    checkAll: '/public/getOperationList',//校验权限
    editUserInfo: '/user/updatePersonalInfo',//编辑用户信息
    userList: '/user/list',//用户列表
    updateStatus: '/user/updateStatus',//更新用户状态
    editUser: '/user/edit',//编辑用户
    addUser: '/user/add',//新增用户
    resetPassword: '/user/resetPassword',//重置密码
    systemNotice: '/public/getSystemNotice',//系统公告
    systemNoticeInfo: '/system/notice/systemNoticeInfo',//系统公告详情
    noticeList: '/system/notice/list',//公告列表
    addNotice: '/system/notice/add',//新增公告
    updateNoticeStatus: '/system/notice/updateStatus',//更新公告状态
    logList: '/system/log/list',//日志列表
    addLog: '/system/log/add',//新增公告
    getSchoolInfo: '/admin/commercial/schoolInfo',//获取商户信息
    updateLogStatus: '/system/log/updateStatus',//更新日志状态
    getSubListByToken: '/admin/account/getSubListByToken',//根据token获取该商户下商户和门店
    getShopList: '/admin/shop/list',//获取店铺
    commercialModify: '/admin/commercial/modify',//编辑商户
    getProvince: '/admin/commercial/getProvince',//获取省
    getCity: '/admin/commercial/getCity',//获取市
    getBank: '/admin/bank/getBank',//获取银行
    getBankBranch: '/admin/bank/getBankBranch',//获取支行
    getBankNo: '/admin/bank/getBankno',//获取支行号

    reportSummary: 'admin/commercial/reportform/summary',//报表统计
    salesSummary: 'admin/commercial/sevendays/sales/summary',//7天销量
    commercialOrderInfo: 'admin/commercial/dailyorderinfo/list',//销售分析
    commercialOrder: 'admin/commercial/sales/analysis', //销售分析（新）
    commercialExport: 'admin/commercial/sales/analysis/export', //导出
    shopMove: '/admin/commercial/drag', //店铺顺序调转
    dataSummary: 'admin/commercial/dailyorderinfo/summary',//销量汇总数据
    financeMerchantBill: 'finance/admin/merchant/bill',//商户数据
    financeMerchantBillSummary: 'finance/admin/merchant/bill/summary',//汇总信息
    financeShopBill: 'finance/admin/shop/bill',//店铺数据
    reportPartnerTrade: 'pub/user/report/partner/trade/v1',
    reportPartnerDinning: 'pub/user/report/partner/dinning/v1',
    reportPartnerSettle: 'pub/user/report/partner/settle/v2',
    reportPartnerExportPDF: 'pub/user/report/partner/export/v1', // 导出pdf
    schoolCompanyExportPDF: 'admin/schoolCompany/reconciliation/bill/export',
    financeShopBillSummary: 'finance/admin/shop/bill/summary',//店铺数据汇总
    financePayBill: 'finance/admin/pay/detail/commercialsys',//财务明细
    financePayBillSummary: 'finance/admin/pay/detail/summary',
    financeTransactionBill: 'admin/transaction/data/order/list',//交易数据
    financeTransactionBillSummary: 'admin/transaction/data/order/summary',//交易数据汇总
    financeTransactionBillTotal: 'admin/transaction/data/order/list/total',//交易数据汇总
    financeTransactionBillDetail: 'admin/transaction/data/order/detail',//详情
    financePayList: 'finance/admin/school/company/month/bill/list',//应付账单
    financePayListBillModify: 'finance/admin/school/company/month/bill/modify',//账单状态更改
    financeExport: '/finance/admin/school/company/month/bill/export',//导出Export
    financeSchoolBill: 'finance/admin/school/aly/bill/list',//应付账单
    checkBillTotalSchool: 'admin/schoolCompany/reconciliation/bill', //校企对账汇总表
    financeSchoolBillSummary: 'finance/admin/school/aly/bill/summary', //校园卡应付账单总计
    reconciliationBillSummary: 'admin/schoolCompany/reconciliation/bill/summary', //店铺、公司财务报表总计总计

    estimateList: 'admin/query/estimate/page',//评价列表
    estimateDetail: 'admin/query/estimate/detail',//评价详情
    estimateOperate: 'admin/operate/estimate',//隐藏/恢复评论
    complaintList: 'admin/complaint/list',//投诉列表
    complaintDetail: 'admin/complaint/detail',//投诉详情
    complaintDispose: 'admin/complaint/dispose',//处理投诉

    adminreFundlist:'admin/refund/list',  //退款列表

    walletInfo: '/admin/wallet/account/data', //钱包信息
    passwordChange: 'payment/v1/user//pay/password/v2', //修改密码
    withdraw: '/payment/v1/user/rmb_buy/withdraw/v2', //钱包提现
    walletData: 'admin/wallet/trade/data', //钱包明细
    billData: 'admin/wallet/account/data/count', //账单统计
    serviceAmount: '/payment/v1/user/rmb_buy/withdraw/pre', //提现手续费
    passwordCheck: 'payment/v1/api/account/pwd/check', //验证身份

    dinnerList: '/admin/dining/list', //餐厅列表
    dinnerModify: '/admin/dining/modify', // 修改餐厅状态
    sendWalletSms: '/admin/captcha/sendWalletSms',

    transportTurnOverDetail: '/admin/transport/turnover/detail',//配送单记录详情

    childAccountList: '/admin/commercialaccount/childAccountList', // 子账号列表
    addChildAccount: '/admin/commercialaccount/addChildAccount', // 添加子账号
    delChildAccount: '/admin/commercialaccount/delChildAccount', // 删除子账号
    dealChildRule: '/admin/commercialaccount/dealChildRule', // 授权子账号
    childRuleInfo: '/admin/commercialaccount/childRuleInfo', // 子账号列表
    resetPwd: '/admin/commercialaccount/resetPwd', // 重置子账号密码

    schoolReport: '/food/report/form', //查询本校报表列表
    schoolReportDelete: '/food/update/report/form', // 删除报表
    schoolReportDownload: '/food/download/report/form', // 下载报表
    schoolReportAdd: '/food/upload/report/form', // 生成报表

    commercialShopList: '/priv/commercial/getShopList', // 总对总门店信息接口
    commercialSchoolsList: '/priv/commercial/getSchoolList', // 总对总学校接口
    commercialShopsList: '/priv/commercial/shopList', // 总对总门店接口
    commercialFulltree2: '/local/school/fulltree2', // 总对总子帐户授权树
    commercialTotalRule: '/admin/commercialaccount/totalRule', // 子账户授权
    commercialTotalRuleInfo: '/admin/commercialaccount/totalRuleInfo', // 子账户详情
    commercialReset: '/priv/commercial/reset', // 子账号重置密码
    commercialGoodsList: '/v2/commercial/query/sale', // 总对总商品
    commercialGood: '/v2/commercial/query/good', // 总对总模糊查询商品名称
    commercialGdStatistics: '/v2/commercial/query/statistics', // 总对总查询订单退款,单数之类
    commercialGdOrderDetail: '/v2/commercial/query/orderDetail', // 总对总查询订单明细
    commercialGdOrderPayWay: '/v1/public/payway/groupV2', // 订单系统的订单支付方式查询
    commercialGdOrderAndGoods: '/v2/commercial/query/orderAndGoods', // 总对总首页当天订单
    commercialGdAmount: '/v2/commercial/query/commercial/amount', // 总对总首页公司
    commercialGdOrderNumber: '/v2/commercial/query/date/orderNumber', // 总对总首页日期图
    commercialGdCountList: '/v2/commercial/order/type/count/list', // 总对总首页订单比例
    commercialGdTimesCountList: '/v2/commercial/order/times/count/list', // 总对总首页订单类型比例
    commercialGdShopAmount: '/v2/commercial/query/shop/amount', // 总对总流量分析
    commercialGdCountOrderDetail: 'v2/commercial/count/query/orderDetail', // 总对总订单总数
    commercialGdReportOrderDetail: '/v2/commercial/report/orderDetail', // 总对总订单明细导出
    commercialGdReportOrderDetail2: '/private/report/count/order/detail', // 总对总订单明细导出2
    
    commercialGdReportList: '/bip/v1/public/report/list', // 总对总历史数据列表
    commercialGdReportListAdd: '/bip/v1/public/report/create', // 总对总新增历史数据
    commercialGdReportDownload: '/bip/v1/public/report/download', // 总对总历史数据下载
    commercialGdReportDelete: '/bip/v1/public/report/delete', // 总对总历史数据删除
    
    // commercialGdOrderNumber: '/v1/private/shop/gd/query/date/orderNumber', // 总对总首页数据

    commercialGdHourData: '/bip/private/v1/bi/group/hour/data', // 总对总今日实时数据
    commercialGdBusinessData: '/bip/private/v1/bi/group/business/detail', // 总对总营业额数据
    commercialGdViewData: '/bip/private/v1/bi/group/view/detail', // 总对总数据流量
    commercialGdSchoolRanking: '/bip/private/v1/bi/group/school/ranking', // 总对总学校排行

    shopQr: '/priv/canteenmanage/shopQr',

    // saas 代理商
    getShopCount: '/priv/commercial/getShopCount', // saas 店铺数
    commercialInfo: '/saas/commercial/info',
    saasShopInfo: '/admin/commercial/saasShopInfo', // 店铺信息
    distinctTree: 'priv/school/distinctTree', // 国标
    bindKq: '/admin/commercial/bindKq', // 绑定快钱
    imgUpload: host.imgsvc + '/img/upload/multipart', // 图片上传
    imgOrc: host.imgsvc + '/img/orc/v1', // 图片识别
    kqUption: '/payment/v1/kuaiqian/file/upload/url', // 快钱上传
}

// let apiUrl = Object.assign(commonApi, businessApi, transportApi);
export default commonApi;


// WEBPACK FOOTER //
// ./vue/common/apiUrl.js